import {
  Card,
  Row,
  Col,
  Form,
  Input,
  Button,
  message,
  Spin,
  Breadcrumb,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import apiService from "../../services/apiService";
import { Link } from "react-router-dom";

function UrinalScreen({ title }) {
  const [form] = Form.useForm();
  const [data, setData] = useState({
    id: "",
    config: {},
    errors: [],
    loading: false,
  });
  const [buttonLoading, setButtonLoading] = useState(false);

  const fetchRecords = useCallback(async () => {
    setData((prev) => ({ ...prev, loading: true }));
    try {
      const response = await apiService.get(
        `settings/view/?step=quotation_builder`
      );
      if (response.status === 200) {
        const config = response.data?.config || {};

        if (config.urinal_screen_price !== undefined) {
          form.setFieldsValue({
            urinal_screen_price: config.urinal_screen_price,
          });
        }

        setData((prevData) => ({
          ...prevData,
          id: response.data.id,
          config: config,
          loading: false,
        }));
      }
    } catch (error) {
      setData((prev) => ({ ...prev, loading: false }));
      console.error("Error fetching records:", error);
      message.error(error.response?.statusText || "Error fetching records");
    } finally {
      setData((prev) => ({ ...prev, loading: false }));
    }
  }, [form]);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  const handleFinish = async (formValues) => {
    setData((prev) => ({ ...prev, loading: true }));
    setButtonLoading(true);
    const request = {
      urinal_screen_price: String(formValues.urinal_screen_price ?? "").trim(),
    };

    try {
      const response = await apiService.post(
        `settings/updateQuotationBuilderUrinalScreenPrice/${data.id}`,
        request
      );
      if (response.status === 200) {
        message.success(response.data.message);
        setData((prev) => ({ ...prev, loading: false, errors: [] }));
        setButtonLoading(false);
      }
    } catch (error) {
      console.error("Error response:", error.response);
      setData((prev) => ({ ...prev, loading: false }));
      setButtonLoading(false);
      if (error.response) {
        if (error.response.status === 422) {
          setData((prev) => ({ ...prev, errors: error.response.data.errors }));
        } else if (error.response.status === 500) {
          setData((prev) => ({ ...prev, errors: [] }));
          message.error(error.response.data.message);
        } else {
          message.error("Something went wrong. Please try again later.");
        }
      } else {
        message.error("Some Problem Occurred! Please try again later.");
      }
    }
  };

  return (
    <div className="container-fluid">
      <Breadcrumb
        style={{ marginBottom: "16px" }}
        items={[
          {
            title: <Link to="/dashboard">Home</Link>,
          },
          {
            title: "Urinal Screen",
          },
        ]}
      />
      <h1 className="h3 mb-4 text-gray-800">{title}</h1>

      <Card>
        <Spin spinning={data.loading}>
          <Row justify="center">
            <Col xs={24} sm={20} md={18} lg={12}>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                requiredMark={false}
              >
                <Form.Item
                  label={
                    <span>
                      Price (Per Screen)<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="urinal_screen_price"
                  validateStatus={
                    data.errors?.urinal_screen_price ? "error" : ""
                  }
                  help={data.errors?.urinal_screen_price?.message}
                  rules={[
                    {
                      required: true,
                      message: "Please enter urinal screen price.",
                    },
                    {
                      validator: (_, value) => {
                        const strVal =
                          value !== undefined && value !== null
                            ? String(value).trim()
                            : "";
                        if (strVal === "") {
                          return Promise.resolve();
                        }
                        if (isNaN(strVal)) {
                          return Promise.reject(
                            new Error("Price must be a valid number.")
                          );
                        }
                        if (strVal.includes(" ")) {
                          return Promise.reject(
                            new Error("Price cannot contain spaces.")
                          );
                        }
                        if (parseFloat(strVal) < 0) {
                          return Promise.reject(
                            new Error("Price must be greater than or equal to 0.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    prefix={<span style={{ color: "blue" }}>$</span>}
                    placeholder="Enter urinal screen price"
                  />
                </Form.Item>

                <Form.Item
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 16,
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                  >
                    {buttonLoading ? "Processing..." : "Update"}
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Spin>
      </Card>
    </div>
  );
}

export default UrinalScreen;
